import { Outlet } from "react-router-dom";
import Header from "../Shared/Header";
//import Sidebar from "../Shared/Sidebar";
import AsideItems from "../Shared/AsideItems";
import { useState } from "react";
import { Drawer, useMediaQuery } from "@mui/material";
import Notifications from "../Components/Websocket/WebsocketNotifications";
import { NotificationProvider } from "../Components/Websocket/NotificationContext";
import WebSocketListeners from "../Components/Websocket/WebsocketListsner";
//import MenuItems from "../Shared/MenuItems";

const Layout = ({ component }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const isMobile = useMediaQuery("(max-width:768px)");

  // const toggleSidebar = () => {
  //   setIsCollapsed((prev) => !prev);
  // };
  const toggleSidebar = () => {
    if (isMobile) {
      setDrawerOpen((prev) => !prev);
    } else {
      setIsCollapsed((prev) => !prev);
    }
  };

  return (
    // <div className="flex h-screen">
    //   <Notifications />
    //   {/* <Sidebar /> */}
    //   {/* <AsideItems isCollapsed={isCollapsed} /> */}
    //   {/* <MenuItems isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} /> */}
    //   {!isMobile && <AsideItems isCollapsed={isCollapsed} />}
    //   {isMobile && (
    //     <Drawer
    //       open={drawerOpen}
    //       onClose={() => setDrawerOpen(false)}
    //       variant="temporary"
    //       PaperProps={{
    //         sx: { width: 250, backgroundColor: "#fff" },
    //       }}
    //     >
    //       <AsideItems isCollapsed={false} />
    //     </Drawer>
    //   )}

    //   <div className="flex flex-col w-full gap-2 p-2 bg-gray-100">
    //     <Header toggleSidebar={toggleSidebar} />
    //     <div className="flex flex-col overflow-y-auto bg-white rounded-lg">
    //       <Outlet />
    //     </div>
    //   </div>
    // </div>

    <NotificationProvider>
      <WebSocketListeners />
      <div className="flex h-screen overflow-hidden">
        <Notifications />
        {!isMobile && (
          <div className="shrink-0">
            <AsideItems isCollapsed={isCollapsed} />
          </div>
        )}

        {isMobile && (
          <Drawer
            open={drawerOpen}
            onClose={() => setDrawerOpen(false)}
            variant="temporary"
            PaperProps={{
              sx: { width: 250, backgroundColor: "#fff" },
            }}
          >
            <AsideItems isCollapsed={false} />
          </Drawer>
        )}

        <div className="flex flex-col flex-1 min-w-0 bg-gray-100">
          <Header toggleSidebar={toggleSidebar} />

          <div className="flex-1 overflow-hidden p-2">
            <div className="h-full overflow-y-auto bg-white rounded-lg p-2">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </NotificationProvider>
  );
};

export default Layout;
